import { useEffect } from 'react';
import { getSsrPayload, clearSsrPayload } from '../utils/ssrBootstrap';

/**
 * Consume Worker-injected learn route payload (no loading state; clears after mount).
 */
export function useSsrLearnRoute(pathname) {
  useEffect(() => {
    const ssr = getSsrPayload();
    if (ssr?.route === 'learn' && ssr.pathname === pathname) {
      clearSsrPayload();
    }
  }, [pathname]);
}
